<template>
    <div class="people-card">
        <div class="card">
            <div class="picture">
                <b-avatar size="95px" :src="people.picture" variant="light"></b-avatar>
            </div>
            <div class="content">
                <h3>{{ people.name }}</h3>
                <h6 class="title">
                    {{ people.title }}
                    <span v-if="people.companyName">at {{ people.companyName }}</span>
                </h6>
                <div class="social-media-links">
                    <a :href="people.facebook" v-if="people.facebook" target="_blank">
                        <i class="icons8-facebook-f"></i>
                    </a>
                    <a :href="people.linkedinUrl" v-if="people.linkedinUrl" target="_blank">
                        <i class="icons8-linkedin-2"></i>
                    </a>
                    <a :href="`https://twitter.com/${people.twitterAccountId}`" v-if="people.twitterAccountId" target="_blank">
                        <i class="icons8-twitter"></i>
                    </a>
                    <a :href="'mailto:' + people.email" v-if="people.email">
                        <i class="icons8-new-post"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'people-card',

    props: {
        people: {
            type: Object,
            default() {
                return {};
            },
        },
    },
};
</script>
<style lang="scss" scoped>
    .people-card {
        max-width: 500px;
        margin: 0 auto;
    }
    .card {
        display: flex;
        flex-direction: row;
        border: none;
        align-items: center;
        padding: 25px 10px;
        border-radius: 5px;

        @include media-breakpoint-up(sm) {
            padding: 25px;
        }
    }

    h3 {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 5px;
        color: #000112;
    }

    h6.title {
        font-size: 15px;
        color: #505B64;
    }

    .picture {
       margin-right: 15px;
    }

    .content {
        width: 75%;
        p {
            margin-bottom: 0;
            font-size: 15px;
            color: #505B64;
            line-height: 21px;
        }

        i {
            color: #D0D0DD;
            font-size: 18px;

            &:hover {
                color: $secondary;
            }
        }
        a {
            margin-right: 10px;
        }
    }
</style>
